import { render, staticRenderFns } from "./commentManagement.vue?vue&type=template&id=7ab79eac&scoped=true"
import script from "./commentManagement.vue?vue&type=script&lang=js"
export * from "./commentManagement.vue?vue&type=script&lang=js"
import style0 from "./commentManagement.vue?vue&type=style&index=0&id=7ab79eac&prod&lang=css"
import style1 from "./commentManagement.vue?vue&type=style&index=1&id=7ab79eac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab79eac",
  null
  
)

export default component.exports